module.exports = __webpack_public_path__ + "images/register/step3-icon.701b3354.svg";